import { render, staticRenderFns } from "./PublicShareSidebar.vue?vue&type=template&id=1772d9d8&scoped=true&"
import script from "./PublicShareSidebar.vue?vue&type=script&lang=js&"
export * from "./PublicShareSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PublicShareSidebar.vue?vue&type=style&index=0&id=1772d9d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1772d9d8",
  null
  
)

export default component.exports